<template>
  <div class="referral">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ title }}
        </h3>
      </div>
      <div class="box-body">
        <table
          id="loan-table"
          class="table table-hover table-striped table-bordered"
        >
          <thead>
            <tr>
              <th>{{ $t('table.action') }}</th>
              <th>{{ $t('table.lendingDate') }}</th>
              <th>{{ $t('table.refundDate') }}</th>
              <th>{{ $t('table.loanId') }}</th>
              <th>{{ $t('table.borrowerId') }}</th>
              <th>{{ $t('table.borrower') }}</th>
              <th>{{ $t('table.amount') }}</th>
              <th>{{ $t('table.estPaybackDate') }}</th>
              <th>{{ $t('table.actPaybackDate') }}</th>
              <th>{{ $t('table.dayDifference') }}</th>
              <th>{{ $t('table.daysOverdue') }}</th>
              <th>{{ $t('table.monthlyInterest') }}</th>
              <th>{{ $t('table.estPaybackAmount') }}</th>
              <th>{{ $t('table.actPaybackAmount') }}</th>
              <th>{{ $t('table.monthYearPayback') }}</th>
              <th>{{ $t('table.principal') }}</th>
              <th>{{ $t('table.interestIncome') }}</th>
              <th>{{ $t('table.lateFee') }}</th>
              <th>{{ $t('table.collacteralNumber') }}</th>
              <th>{{ $t('table.typeOfCollacteral') }}</th>
              <th>{{ $t('table.isRepeatBorrower') }}</th>
              <th>{{ $t('table.needToCollect') }}</th>
              <th>{{ $t('table.moneySent') }}</th>
              <th>{{ $t('table.payback') }}</th>
              <th>{{ $t('table.provideCollateral') }}</th>
            </tr>
          </thead>
          <tbody />
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoanList',
  props: {
    filter: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  watch: {
    '$i18n.locale': function () {
      this.oTable.clear()
      this.oTable.destroy()
      this.oTable = this.dataTable()
      this.oTable.draw(true)
    }
  },
  computed: {
    columns () {
      return [
        {
          data: 'action',
          name: 'action',
          searchable: false,
          orderable: false,
          width: '20%',
          titleKey: 'table.action',
          title: this.$t('table.action')
        },
        {
          data: 'approved_at',
          name: 'approved_at',
          width: '8%',
          title: this.$t('table.lendingDate')
        },
        {
          data: 'end',
          name: 'end',
          searchable: false,
          orderable: false,
          width: '8%',
          title: this.$t('table.refundDate')
        },
        { data: 'search_loan_id', name: 'search_loan_id', width: '8%', title: this.$t('table.loanId') },
        {
          data: 'borrow.search_borrower_id',
          name: 'borrow.search_borrower_id',
          width: '8%',
          title: this.$t('table.borrowerId')
        },
        { data: 'borrow.name', name: 'borrow.name', width: '8%', title: this.$t('table.borrower') },
        { data: 'amount', name: 'amount', width: '8%', title: this.$t('table.amount') },
        {
          data: 'est_payback_date',
          name: 'est_payback_date',
          width: '8%',
          title: this.$t('table.estPaybackDate')
        },
        {
          data: 'act_payback_date',
          name: 'act_payback_date',
          width: '8%',
          title: this.$t('table.actPaybackDate')
        },
        {
          data: 'day_difference',
          name: 'day_difference',
          width: '8%',
          title: this.$t('table.dayDifference')
        },
        { data: 'days_overdue', name: 'days_overdue', width: '8%', title: this.$t('table.daysOverdue') },
        {
          data: 'monthly_interest',
          name: 'monthly_interest',
          width: '8%',
          title: this.$t('table.monthlyInterest')
        },
        {
          data: 'est_payback_amount',
          name: 'est_payback_amount',
          width: '8%',
          title: this.$t('table.estPaybackAmount')
        },
        {
          data: 'act_payback_amount',
          name: 'act_payback_amount',
          width: '8%',
          title: this.$t('table.actPaybackAmount')
        },
        {
          data: 'month_year_payback',
          name: 'month_year_payback',
          width: '8%',
          title: this.$t('table.monthYearPayback')
        },
        { data: 'principal', name: 'principal', width: '8%', title: this.$t('table.principal') },
        {
          data: 'interest_income',
          name: 'interest_income',
          width: '8%',
          title: this.$t('table.interestIncome')
        },
        { data: 'late_fee', name: 'late_fee', width: '8%', title: this.$t('table.lateFee') },
        {
          data: 'collacteral_number',
          name: 'collacteral_number',
          width: '8%',
          title: this.$t('table.collacteralNumber')
        },
        {
          data: 'type_of_collacteral',
          name: 'type_of_collacteral',
          width: '8%',
          title: this.$t('table.typeOfCollacteral')
        },
        {
          data: 'is_repeat_borrower',
          name: 'is_repeat_borrower',
          width: '8%',
          title: this.$t('table.isRepeatBorrower')
        },
        {
          data: 'need_to_collect',
          name: 'need_to_collect',
          width: '8%',
          title: this.$t('table.needToCollect')
        },
        { data: 'money_sent', name: 'money_sent', width: '8%', title: this.$t('table.moneySent') },
        { data: 'payback', name: 'payback', width: '8%', title: this.$t('table.payback') },
        {
          data: 'provide_collateral',
          name: 'provide_collateral',
          width: '8%',
          title: this.$t('table.provideCollateral')
        }
      ]
    }
  },
  methods: {
    refreshDataTable () {
      this.oTable.draw(true)
    },
    refundOrRevert (id, type) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: self.$t('string.yesDeleteIt'),
        cancelButtonText: self.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          self.$isLoading(true)
          self.$axios.post(process.env.VUE_APP_API + '/api/v1/loan/refund', {
            id: id,
            type: type
          }).then((response) => {
            if (response.data.code === 1) {
              self.refreshDataTable()
              this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
            }
          })
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    updateUnknownLoanType (uuid, loan_type) {
      const self = this
      this.$swal({
        title: self.$t('string.areYouSure?'),
        text: self.$t('string.youWillNotBeAbleToRevertThis!'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Update'
      }).then((result) => {
        if (result.value) {
          self.$isLoading(true)
          self.$axios.post(process.env.VUE_APP_API + '/api/v1/loan/update-unknown-loan-type', {
            uuid: uuid,
            loan_type: loan_type
          }).then((response) => {
            if (response.data.code === 1) {
              self.refreshDataTable()
              this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
            }
          })
        }
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    dataTable () {
      const self = this
      return $('#loan-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/loan',
          data: (d) => {
            d.filter = self.filter
            d.labelShow = self.$t('label.show')
            d.labelEdit = self.$t('label.edit')
            d.labelRefund = self.$t('label.refund')
            d.labelNotPaid = self.$t('label.notPaid')
            d.noPermission = self.$t('string.noPermission')
          },
          error: (xhr) => {
            this.onAccessDenied(xhr)
          }
        },
        columns: self.columns,
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        },
        order: [[1, 'desc']]
      })
    },
    setButtonAction () {
      this.clearEventHandlers([
        '.refund',
        '.edit',
        '.showLoan',
        '.revert',
        '.view-client'
      ])
      const self = this
      $(document).on('click', '.refund', function () {
        const id = $(this).attr('data-loan')
        self.refundOrRevert(id, 'refund')
      })

      $(document).on('click', '.showLoan', function () {
        self.$router.push({
          name: 'show-loan',
          params: {
            loan_id: $(this).attr('data-loan')
          }
        })
      })

      $(document).on('click', '.edit', function () {
        self.$router.push({
          name: 'edit-loan',
          params: {
            loan_id: $(this).attr('data-loan')
          }
        })
      })

      $(document).on('click', '.revert', function () {
        const id = $(this).attr('data-loan')
        self.refundOrRevert(id, 'revert')
      })

      $(document).on('click', '.view-client', function () {
        const borrow_id = $(this).attr('data-id')
        window.open(`/admin/borrow/client/show/${borrow_id}`, '_blank')
      })
    }
  },
  mounted () {
    const self = this
    this.$nextTick(() => {
      $(function () {
        self.oTable = self.dataTable()
        self.setButtonAction()
      })
    })
  },
  beforeDestroy () {
    this.oTable.clear()
    this.oTable.destroy()
  }
}
</script>

<style scoped>

</style>
